import React from 'react';
import _ from 'lodash';

import {
  InventoryActivity_TemplateTabDocument,
  InventoryActivity_TemplateTabQuery,
  SaveListingManagementStrategyTemplateGroupMutation,
  SaveListingManagementStrategyTemplateGroup_TemplateInput,
  useSaveListingManagementStrategyTemplateGroupMutation
} from 'generated/graphql';

import { DateTime } from 'luxon';
import { gqlCacheUtil } from 'modules';
import * as types from './types';



export function useSaveListingManagementStrategyTemplateGroup() {
  const [fnMutate, tuple] = useSaveListingManagementStrategyTemplateGroupMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            name: formState.name,
            templates: _.map(formState.items, (item): SaveListingManagementStrategyTemplateGroup_TemplateInput => ({
              itemId: item.itemId,
              priceDollars: item.defaultPriceDollars.toFixed(2)
            }))
          }
        },

        optimisticResponse: {
          saveListingManagementStrategyTemplateGroup: {
            id: '',
            createdTimestamp: DateTime.now().toISO(),
            name: formState.name,
            templateCount: 0,
            templates: {
              nodes: formState.items.map(item => ({
                id: '',
                item: {
                  id: item.itemId,
                  name: '',
                  sku: ''
                },
                priceDollars: item.defaultPriceDollars.toFixed(2)
              })),
              pageInfo: {
                pages: [],
                totalRows: formState.items.length
              }
            }
          }
        },

        updateQueries: gqlCacheUtil.genUpdateQueryMap<InventoryActivity_TemplateTabQuery, SaveListingManagementStrategyTemplateGroupMutation>(
          InventoryActivity_TemplateTabDocument,
          (previousState: InventoryActivity_TemplateTabQuery, { mutationResult }) => ({
            ...previousState,
            listingManagementStrategyTemplateGroups: {
              ...previousState.listingManagementStrategyTemplateGroups,
              nodes: _.compact([
                ...previousState.listingManagementStrategyTemplateGroups.nodes,
                mutationResult.data?.saveListingManagementStrategyTemplateGroup
              ])
            }
          }))
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
